import { CompanyMinifiedType as ApiCompanyMinifiedType } from 'src/api/generated/touring/types';
import { mapAddress, mapContact } from '../common';
import { CompanyMinifiedRowType } from './types';

export const mapCompanyMinifiedType = (
  apiCompany: ApiCompanyMinifiedType
): CompanyMinifiedRowType => ({
  id: apiCompany.id,
  name: apiCompany.name,
  headquarters: mapContact(apiCompany.headquarters),
  address: mapAddress(apiCompany.address),
  tags: apiCompany.tags,
});
